import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "as"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import ButtonBase from '../ButtonBase';
const Root = styled(ButtonBase).withConfig({
  displayName: "IconButton__Root",
  componentId: "sc-qgu8rz-0"
})(["padding-left:", ";padding-right:", ";"], _ref => {
  let {
    size
  } = _ref;
  return size === ButtonBase.sizes.md ? 'var(--size-spacing-02)' : 'var(--size-spacing-01)';
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size === ButtonBase.sizes.md ? 'var(--size-spacing-02)' : 'var(--size-spacing-01)';
});
const IconButton = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
      children,
      as
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    forwardedAs: as
  }, rest), children);
});
IconButton.displayName = 'IconButton';

/**
 * @deprecated
 * It will be removed soon, because you can directly use IconButton to extend the style
 */
IconButton.style = IconButton;
IconButton.kinds = ButtonBase.kinds;
IconButton.types = ButtonBase.types;
IconButton.sizes = ButtonBase.sizes;
IconButton.defaultProps = {
  children: '',
  type: IconButton.types.button,
  kind: IconButton.kinds.primary,
  size: IconButton.sizes.md,
  as: undefined
};
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  /**
   * Set element type to be rendered for this component. By default it will be render a `<button>` element.
   */
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Sets button children
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]),
  /**
   * Sets button type
   */
  type: PropTypes.oneOf([IconButton.types.button, IconButton.types.submit, IconButton.types.reset]),
  /**
   * Sets button kind for styling
   */
  kind: PropTypes.oneOf([IconButton.kinds.primary, IconButton.kinds.secondary, IconButton.kinds.tertiary, IconButton.kinds.neutral, IconButton.kinds.danger]),
  /**
   * Sets the button size
   */
  size: PropTypes.oneOf([IconButton.sizes.sm, IconButton.sizes.md])
} : void 0;
export default IconButton;